import { useEffect } from 'react';
import { useDispatch, useSelector, useStore } from 'react-redux';
import { useLocation, useNavigate } from 'react-router-dom';
import ReactGA from 'react-ga4';
import { gapi } from 'gapi-script';
import setUpInterceptor from '../../Utilidades/interceptors';
import { authInitialized } from '../../stores/App';
import { getToken, getApiCliGoo, setCurrentPa } from '../../Utilidades/session';
import { StatusAlertService } from 'react-status-alert';
import { redipa } from '../../stores/AuthUser';

export const AuthInterceptor = () => {
  const store = useStore();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const clientId = getApiCliGoo();
  const initialized = useSelector((state: any) => {
    return state.app.authInitialized;
  });
  const authUser = useSelector((state: any) => {
    return state.authUser;
  });
  const pantallas = useSelector((state: any) => state.authUser.pantallas);
  const location = useLocation();
  const PUBLIC_PATHS = [
    '',
    'banners',
    'popups',
    //'vista-comunicado',
    //'solicitar-comunicado',
    'sobre-nosotros',
    //Modificacion: Marca de Inicio WII C-24-1229-24
    'aviso-privacidad',
    //Modificacion: Marca de Fin WII C-24-1229-24
    'pagina-error',
  ]; // Always use LowerCase
  const PRIVATE_PATHS = [
    'vista-comunicado',
    //'solicitar-comunicado',
    'buscador',
  ]; // Always use LowerCase
  //Modificacion: Marca de Inicio WII C-24-1229-24
  const PRIVATENOR_PATHS = [
    'vista-comunicado',
  ];
  //Modificacion: Marca de Fin WII C-24-1229-24
  useEffect(() => {
    setUpInterceptor(store, navigate); //<-- initialize the interceptor here
  }, []);
  useEffect(() => {
    const currentPath = location.pathname ? location.pathname : '/';
    const parts = currentPath.split('/');
    const path = parts[1].toLowerCase();
    if (
      (!getToken() && !PUBLIC_PATHS.includes(path)) ||
      (initialized &&
        !PUBLIC_PATHS.includes(path) &&
        (!PRIVATE_PATHS.includes(path) && getToken()) &&
        (!authUser.loggedIn ||
          !authUser.pantallas.some((p) => p.link.toLowerCase() === path)))
    ) {
      //StatusAlertService.showError("No cuentas con acceso al recurso");
      //Modificacion: Marca de Inicio WII C-24-1229-24
      const data = {
        panta: currentPath
      };

      setCurrentPa("regresar")
      dispatch(redipa(data));

      if (!PRIVATENOR_PATHS.includes(path) || !getToken()) {
        navigate('/', { replace: true });
      }
    } else {

      if (currentPath != "/" && currentPath != "") {
        const data = {
          panta: ""
        };

        setCurrentPa("")
        dispatch(redipa(data));
      }
      //Modificacion: Marca de Fin WII C-24-1229-24

      window.scrollTo({
        top: 0,
        behavior: 'smooth', // for smoothly scrolling
      });
      ReactGA.send({ hitType: 'pageview', page: location.pathname });
    }
  }, [location, initialized]);

  useEffect(() => {
    const initClient = () => {
      gapi.client
        .init({
          clientId: clientId,
          scope: '',
        })
        .then(() => {
          // setTimeout(() => {
          //   dispatch(authInitialized());
          // }, 2000);
        });
    };
    gapi.load('client:auth2', initClient);
  }, []);
  return <></>;
};
